import {ToggleTitle, Wrapper} from "./styles";
import {useState} from "react";

interface IToggleList {
    titles: string[];
    content: any;
    setActive?: (i: number) => void;
}

export const ToggleList: React.FC<IToggleList> = ({titles, content, setActive}) => {

    const [selectedTitle, setSelectedTitle] = useState<number>(0)

    const Element = content[selectedTitle]

    return (
        <Wrapper>
            <div>
                {titles.map((title, i) => <ToggleTitle  id='bold'
                    key={i}
                    selected={i === selectedTitle}
                    onClick={() => {
                        setSelectedTitle(i)
                        setActive && setActive(i)
                    }}
                >
                    {title}
                </ToggleTitle>)}
            </div>
                <div>
                    {Element}
                </div>
        </Wrapper>
    )
}
